import AppPermissions from './index.jsx';
import messages from './messages.js';

const template = {
  header: messages.topics,
  headerHelp: messages.topicsHelp,
  switch: true,
  options: [
    { value: 10, label: messages.withNone },
    { value: 20, label: messages.withEmployees },
    { value: 30, label: messages.withAllMembers },
  ],
  exceptions: true,
};

function TopicPermissions(props) {
  return AppPermissions({ ...props, template });
}

export default TopicPermissions;
